
import Vue, { PropType } from 'vue'
import { AheduTabsItem } from './AheduTabsItem'

export default Vue.extend({
  name: 'AheduTabs',
  props: {
    /**
     * 具体配置项可参考AheduTabsItem
     */
    tabs: {
      type: Array as PropType<AheduTabsItem[]>,
    },
    tab: String,
    /**
     * 当前高亮的是否触发click事件
     * 默认不触发
     */
    activeClickable: Boolean,
  },
  methods: {
    onClick(t: AheduTabsItem): void {
      if (this.activeClickable === false) {
        if (t.key === this.tab) {
          return
        }
      }

      if (t.onClick) {
        t.onClick()
      }
      this.$emit('click', t.key, t)
    },
  },
})
